import React from 'react';
import { CommonOrganismProps } from '../../types';
import Section from '..';

export interface SectionWithTwoLevelListProps extends CommonOrganismProps {
  items: { levelOneText: string; levelTwoTexts?: string[] }[];
}

export default function SectionWithTwoLevelList({ title, items, styles, ...restProps }: SectionWithTwoLevelListProps) {
  return (
    <Section title={title} styles={styles} {...restProps}>
      <div className="h-64 overflow-auto md:h-full md:overflow-visible w-full flex flex-col pt-3">
        <div className="">
          <div className="flex flex-wrap gap-x-4 gap-y-2">
            <ul className="list-decimal list-inside flex flex-col gap-3 md:gap-1">
              {items?.map(item => (
                <li key={item?.levelOneText}>
                  <strong>{item?.levelOneText}</strong>
                  <ol className="list-[lower-roman] list-inside pl-4">
                    {item?.levelTwoTexts?.map(text => (
                      <li key={text}>{text}</li>
                    ))}
                  </ol>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </Section>
  );
}
